// extracted by mini-css-extract-plugin
export var box = "_3a-0";
export var check = "_3a-1";
export var checkboxButton = "_3a-6";
export var checkboxGroup = "_3a-5";
export var disabled = "_3a-7";
export var ghost = "_3a-9";
export var input = "_3a-2";
export var label = "_3a-4";
export var normal = "_3a-8";
export var uncheck = "_3a-3";